var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSellerDeliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#21252A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.495 16.827c.193 0 .394-.058.602-.172l5.844-3.297c.328-.188.573-.4.734-.637.161-.237.242-.603.242-1.098V5.678c0-.349-.068-.64-.203-.875-.135-.234-.346-.435-.633-.601l-5.344-3.024c-.416-.234-.83-.351-1.242-.351-.411 0-.825.117-1.242.351L2.917 4.202c-.286.166-.499.367-.637.601-.138.234-.207.526-.207.875v5.945c0 .495.084.861.25 1.098.167.237.412.45.735.637l5.851 3.297c.198.114.394.172.586.172zm3.5-10.508l-5.86-3.29 1.579-.898c.531-.302 1.052-.302 1.563 0l5.054 2.875-2.336 1.313zm-3.5 1.968L3.66 5.008 6.073 3.63l5.844 3.297-2.422 1.36zm-.523 7.188l-5.297-2.992c-.219-.125-.37-.254-.453-.387-.083-.133-.125-.303-.125-.512v-5.68l5.875 3.321v6.25zm1.055 0v-6.25l5.875-3.32v5.68c0 .208-.042.378-.125.511-.084.133-.237.262-.461.387l-5.29 2.992z",
    transform: "translate(-146 -1604) translate(0 1369) translate(16 53) translate(0 10) translate(0 101) translate(0 56) translate(130 14) translate(0 1)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSellerDeliver);
export default __webpack_public_path__ + "static/media/ic_seller_deliver.adabb33fda10dad0dbde350aec2e4b11.svg";
export { ForwardRef as ReactComponent };